import { createContext, useContext } from 'react'

type HomeContextErrorKey =
  | 'HELPER_SCHEDULE_ERROR'
  | 'OPEN_SHIFTS_SCHEDULE_ERROR'
  | 'NOTIFICATIONS_SUMMARY_ERROR'
  | 'TIME_OFF_REQUESTS_ERROR'
  | 'UPDATE_APP_ERROR'
  | 'MONTHLY_SUMMARY_ERROR'

type MessageContextErrorKey =
  | 'MESSAGES_ERROR'
  | 'CHAT_CONFIG_ERROR'
  | 'CONVERSATIONS_ERROR'

type ErrorKey =
  | MessageContextErrorKey
  | HomeContextErrorKey
  | 'USER_ERROR'
  | 'STORES_ERROR'
  | 'COMPANY_PREFERENCES_ERROR'
  | 'NOTIFICATIONS_ERROR'

export type QueryErrors = {
  [key in ErrorKey]?: unknown
}

interface ConceptQueryErrorContextValue {
  queryErrors: QueryErrors
}

const ConceptQueryErrorContext = createContext(
  {} as ConceptQueryErrorContextValue
)

export function useConceptQueryErrorContext() {
  return useContext(ConceptQueryErrorContext)
}

interface Props {
  children: React.ReactNode
  queryErrors: QueryErrors
}
export function ConceptQueryErrorProvider(props: Props) {
  return (
    <ConceptQueryErrorContext.Provider
      value={{
        queryErrors: props.queryErrors,
      }}
    >
      {props.children}
    </ConceptQueryErrorContext.Provider>
  )
}
